"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarCheckboxFilter = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const bi_1 = require("react-icons/bi");
const hooks_1 = require("../hooks");
const colors_1 = require("../utils/colors");
const HackerTooltip_1 = require("./HackerTooltip");
const SidebarCheckboxFilter = ({ isChecked, onChange, label, tooltip, }) => {
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const handleClick = (0, react_2.useCallback)(() => {
        return onChange === null || onChange === void 0 ? void 0 : onChange(!isChecked);
    }, [isChecked, onChange]);
    return (react_2.default.createElement(HackerTooltip_1.HackerTooltip, { label: tooltip, isDisabled: !tooltip, openDelay: 500, bgColor: "black" },
        react_2.default.createElement(react_1.Flex, { alignItems: "center", fontSize: "12px", cursor: "pointer", userSelect: "none", w: "full", fontWeight: "semibold", py: 4, px: 2, borderColor: primaryColor, borderTopWidth: "1px", _hover: {
                bgColor: (0, colors_1.alphaColor)(primaryColor, 0.1),
            }, _active: {
                bgColor: (0, colors_1.alphaColor)(primaryColor, 0.15),
            }, onClick: handleClick },
            react_2.default.createElement(react_1.Flex, { flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", mr: 2 }, label),
            react_2.default.createElement(react_1.Flex, { fontSize: "16px", mr: 2 }, isChecked ? react_2.default.createElement(bi_1.BiCheckboxSquare, null) : react_2.default.createElement(bi_1.BiCheckbox, null)))));
};
exports.SidebarCheckboxFilter = SidebarCheckboxFilter;
//# sourceMappingURL=SidebarCheckboxFilter.js.map